<script setup>
import { ref, computed } from "vue";
import { useAuthStore } from '@/store/auth';
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();
// Datos de ejemplo
const allData = ref(authStore.infoAcces.mandatos);

// Estado de la paginación
const currentPage = ref(1);
const itemsPerPage = 5;

// Calcular datos para la página actual
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return allData.value.slice(start, end);
});

// Calcular el total de páginas
const totalPages = computed(() => Math.ceil(allData.value.length / itemsPerPage));
// Cambiar de página
const goToPage = (page) => {
  if (page > 0 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

const viewPobwerbi = (item)=>{
  localStorage.setItem('idmandato', item)
  router.push("powerbi");
};
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Mandatos</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Pertenece</th>
              <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Employed</th> -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="text-uppercase mb-0 text-sm">{{ item }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ item }}</p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ authStore.infoAcces.user }}  {{ authStore.infoAcces.apellidos }}</p>
              </td>
              <!-- <td class="align-middle text-center text-sm">
                <span :class="['badge badge-sm', item.status === 'Online' ? 'bg-gradient-success' : 'bg-gradient-secondary']">
                  {{ item.status }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ item.date }}</span>
              </td> -->
              <td class="align-middle">
                <a href="javascript:;" class="text-secondary font-weight-bold text-xs" @click="viewPobwerbi(item)">Ver</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Paginación -->
      <nav>
        <ul class="pagination justify-content-center mt-3">
          <li class="page-item" :class="{ disabled: currentPage === 1 }"> 
            <button class="page-link" @click="goToPage(currentPage - 1)"> &lt; </button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
            <button class="page-link" @click="goToPage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="goToPage(currentPage + 1)">></button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
